// ── Ícone da aba do navegador ───────────────────────────────────────────────
// A pistola (SVG embutido em public/index.html) é repintada com a cor de destaque do tema.
// Se a cor não for um hex válido, usa o bronze do visual institucional.
export const FAVICON_FALLBACK = "#D08A4F";

let baseSvg = null;   // SVG original, lido uma vez do <link rel="icon">

function readBase(link) {
  if (baseSvg) return baseSvg;
  const m = /^data:image\/svg\+xml,(.*)$/s.exec(link.getAttribute("href") || "");
  if (!m) return null;
  try { baseSvg = decodeURIComponent(m[1]); } catch { baseSvg = m[1]; }
  return baseSvg;
}

export function setFavicon(color) {
  try {
    const link = document.querySelector('link[rel="icon"]');
    if (!link) return;
    const svg = readBase(link);
    if (!svg) return;
    const c = /^#[0-9a-fA-F]{6}$/.test(color || "") ? color : FAVICON_FALLBACK;
    const next = svg.replace(/fill=(['"])[^'"]*\1/, `fill='${c}'`);     // 1º fill = o da pistola
    link.setAttribute("href", "data:image/svg+xml," + encodeURIComponent(next));
  } catch {}
}
